import IconBase from "react-icon-base";

export default function Icon(props) {
  return (
    <IconBase
      {...props}
      viewBox={"0 0 24 24"}
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="iso-8859-1"?>
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 502.642 502.642" style="enable-background:new 0 0 502.642 502.642;" xml:space="preserve">
		<path d="M379.247,179.534h-92.043v-44.867c0,0-5.155-42.667,24.677-42.667c33.715,0,60.635,0,60.635,0V0
			H269.279c0,0-86.391-0.367-86.391,86.391c0,18.637-0.086,52.568-0.216,93.143h-59.277v74.074h59.125
			c-0.345,117.776-0.755,249.035-0.755,249.035h105.438V253.608h69.587L379.247,179.534z"/>
</svg>
`,
      }}
    />
  );
}
